
<template>
  <div>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" @click="handleadd()"
          >添加实验</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      size="small"
      :data="list"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column prop="name" label="实验名称"> </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加实验" :visible.sync="addVis" width="80%">
      <el-form
        label-position="right"
        :model="dataParams"
        label-width="100px"
        ref="addManref"
      >
        <el-form-item label="实验名称:">
          <el-input v-model="dataParams.name"></el-input>
        </el-form-item>
        <el-form-item label="步骤:"> </el-form-item>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="步骤名称:">
              <el-input v-model="title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="实验用时:">
              <el-input v-model.number="expectTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="实验满分值:">
              <el-input v-model.number="maxScore"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="success" @click="addlist">添加</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="shiyanlist" style="width: 100%">
        <el-table-column prop="title" label="步骤名称"> </el-table-column>

        <el-table-column prop="expectTime" label="实验用时"> </el-table-column>
        <el-table-column prop="maxScore" label="实验满分值"> </el-table-column>
        <el-table-column prop="" label="编辑">
          <template slot-scope="scope">
            <el-button size="mini" @click="dellistdata(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVis = false">取 消</el-button>
        <el-button type="primary" @click="addMandata">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { lablist, labdelete, labcreate, labedit } from "@/api/userMG";

export default {
  data() {
    return {
      list: [],
      addVis: false,
      dataParams: {
        name: "",
        step: "",
        title: [],
        expectTime: [],
        maxScore: [],
      },
      shiyanlist: [],
      title: "",
      expectTime: "",
      maxScore: "",
      editid: "",
    };
  },
  created() {
    this.getlabListfn();
  },
  methods: {
    //编辑实验
    handleEdit(item) {
      this.dataParams.name = item.name;
      this.editid = item.labId;
      this.shiyanlist = [];
      for (let index = 0; index < item.step; index++) {
        let itemdata = {
          title: item.title[index],
          expectTime: item.expectTime[index],
          maxScore: item.maxScore[index],
          index: index + 1,
        };
        this.shiyanlist.push(itemdata);
      }

      this.addVis = true;
    },
    //添加实验
    addMandata() {
      if (!this.dataParams.name) {
        this.$message.warning("请输入实验名称");
        return;
      }
      if (this.shiyanlist.length <= 0) {
        this.$message.warning("请添加步骤");
        return;
      }
      this.dataParams.title = [];
      this.dataParams.expectTime = [];
      this.dataParams.maxScore = [];
      this.dataParams.step = this.shiyanlist.length;
      this.shiyanlist.forEach((item) => {
        this.dataParams.title.push(item.title);
        this.dataParams.expectTime.push(item.expectTime);
        this.dataParams.maxScore.push(item.maxScore);
      });
      if (this.editid) {
        labedit(this.dataParams, this.editid).then((res) => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.addVis = false;
          this.getlabListfn();
        });
      } else {
        labcreate(this.dataParams).then((res) => {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.addVis = false;
          this.getlabListfn();
        });
      }
    },
    // 删除实验
    dellistdata(data) {
      let indexs = this.shiyanlist.findIndex(
        (item) => item.index == data.index
      );
      console.log(this.shiyanlist.splice(indexs, 1));
    },
    //添加实验步骤
    addlist() {
      if (!this.title) {
        this.$message.warning("请输入步骤名称");
        return;
      }
      if (!this.expectTime) {
        this.$message.warning("请输入实验用时");
        return;
      }
      if (!this.maxScore) {
        this.$message.warning("请输入实验满分值");
        return;
      }
      if (!Number.isInteger(this.expectTime)) {
        this.$message.warning("实验用时必须为整数");
        return;
      }
      if (!Number.isInteger(this.maxScore)) {
        this.$message.warning("实验满分值必须为整数");
        return;
      }
      let item = {
        title: this.title,
        expectTime: this.expectTime,
        maxScore: this.maxScore,
        index: this.shiyanlist.length + 1,
      };
      this.shiyanlist.push(item);
      this.title = "";
      this.expectTime = "";
      this.maxScore = "";
      console.log(this.shiyanlist);
    },
    //添加实验
    handleadd() {
      this.addVis = true;
      this.editid = "";
    },
    //删除实验步骤
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          labdelete(row.labId)
            .then((res) => {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getlabListfn();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getlabListfn() {
      lablist().then((res) => {
        this.list = res;
      });
    },
  },
};
</script>

<style scoped>
</style>

 
 


// WEBPACK FOOTER //
// src/views/admin/school/shiyanguanli.vue